import './card-list.scss';
import Splide from '@splidejs/splide';

export class CardList {
  constructor() {
    this.elements = document.querySelectorAll('.js-card-list-slider');
    if (!this.elements.length) return;

    this.instances = [];

    this.init();
  }

  init() {
    this.elements.forEach((el) => {
      const section = el.closest('.card-list');

      if (!section.classList.contains('card-list--slider')) return;

      const ctx = {
        el,
        section,
        splide: null,
        mediaQuery: window.matchMedia('(min-width: 1290px)'),
      };

      this.instances.push(ctx);
      this.setup(ctx);
    });
  }

  setup(ctx) {
    this.handle(ctx, ctx.mediaQuery);

    ctx.mediaQuery.addEventListener('change', (e) => {
      this.handle(ctx, e);
    });
  }

  handle(ctx, e) {
    const slidesCount = ctx.el.querySelectorAll('.splide__slide').length;

    if (e.matches) {
      if (slidesCount > 3) {
        if (!ctx.splide) {
          this.mount(ctx, 3);
        }
      } else {
        this.destroy(ctx);
      }
    } else if (!ctx.splide) {
      this.mount(ctx, 1.2);
    } else {
      this.updateOptions(ctx, { perPage: 1.2 });
    }
  }

  mount(ctx, perPage) {
    const splide = new Splide(ctx.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '24px',
      perPage,
      focus: 0,
      drag: true,
      trimSpace: true,
      snap: true,
    });

    splide.mount();

    // 👉 aggiorno stato SENZA mutare parametro
    this.replaceInstance(ctx, { splide });

    this.initArrows(ctx);
  }

  destroy(ctx) {
    if (!ctx.splide) return;

    ctx.splide.destroy(true);
    this.replaceInstance(ctx, { splide: null });
  }

  updateOptions(ctx, options) {
    if (!ctx.splide) return;

    ctx.splide.options = {
      ...ctx.splide.options,
      ...options,
    };
  }

  replaceInstance(oldCtx, updates) {
    const index = this.instances.indexOf(oldCtx);
    if (index === -1) return;

    this.instances[index] = {
      ...oldCtx,
      ...updates,
    };
  }

  initArrows(ctx) {
    const prev = ctx.el.querySelector('.splide__arrow--prev');
    const next = ctx.el.querySelector('.splide__arrow--next');

    const update = () => {
      const current = this.instances.find((i) => i.el === ctx.el);
      if (!current.splide) return;

      const { index } = current.splide;
      const last = current.splide.length - current.splide.options.perPage;

      next.classList.toggle('is-disabled', index >= last);
      prev.classList.toggle(
        'is-removed',
        current.splide.length <= current.splide.options.perPage,
      );
      next.classList.toggle(
        'is-removed',
        current.splide.length <= current.splide.options.perPage,
      );
    };

    update();

    const current = this.instances.find((i) => i.el === ctx.el);
    current.splide.on('mounted move', update);
  }
}
